import React from 'react';
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Sparkles } from 'lucide-react';

const PortfolioSection = () => {
  return (
    <section id="portfolio" className="py-20 px-4 sm:px-6 lg:px-8" data-testid="portfolio-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <Badge className="bg-blue-600/20 text-blue-400 border-blue-600/30 mb-4" data-testid="portfolio-badge">
            Our Work
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-testid="portfolio-title">
            Featured Projects
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto" data-testid="portfolio-description">
            Explore our portfolio of successful ventures built with cutting-edge technology.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* SoleSocial Project */}
          <Card className="bg-slate-800/50 border-slate-700 overflow-hidden group hover:border-blue-500 transition-all" data-testid="project-card-solesocial">
            <div className="relative h-64 overflow-hidden">
              <img 
                src="https://images.pexels.com/photos/6498730/pexels-photo-6498730.jpeg" 
                alt="SoleSocial App" 
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                data-testid="project-image-solesocial"
              />
              <div className="absolute top-4 right-4">
                <Badge className="bg-green-600" data-testid="project-status-solesocial">Live</Badge>
              </div>
            </div>
            <CardHeader>
              <CardTitle className="text-white text-2xl" data-testid="project-title-solesocial">SoleSocial.app</CardTitle>
              <CardDescription className="text-slate-300 text-base">
                A cutting-edge social platform for sneaker enthusiasts. Connect, share, and discover 
                the latest drops in a vibrant community of collectors and fans.
              </CardDescription>
              <div className="flex flex-wrap gap-2 mt-4">
                <Badge variant="outline" className="border-slate-600 text-slate-300">React</Badge>
                <Badge variant="outline" className="border-slate-600 text-slate-300">FastAPI</Badge>
                <Badge variant="outline" className="border-slate-600 text-slate-300">MongoDB</Badge>
                <Badge variant="outline" className="border-slate-600 text-slate-300">AI-Powered</Badge>
              </div>
            </CardHeader>
          </Card>

          {/* Future Projects Placeholder */}
          <Card className="bg-slate-800/50 border-slate-700 border-dashed" data-testid="project-card-coming-soon">
            <CardHeader className="h-full flex flex-col items-center justify-center text-center py-20">
              <Sparkles className="w-16 h-16 text-slate-600 mb-4" />
              <CardTitle className="text-white text-2xl mb-2" data-testid="project-title-coming-soon">More Coming Soon</CardTitle>
              <CardDescription className="text-slate-400 text-base">
                We're constantly building innovative digital products across multiple verticals. 
                Stay tuned for exciting launches in e-commerce, enterprise tools, marketplaces, and beyond.
              </CardDescription>
            </CardHeader>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;